import { render } from "./item-option-value-modal.vue?vue&type=template&id=88a9f620&scoped=true"
import script from "./item-option-value-modal.vue?vue&type=script&lang=js"
export * from "./item-option-value-modal.vue?vue&type=script&lang=js"

import "./item-option-value-modal.vue?vue&type=style&index=0&id=88a9f620&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88a9f620"]])

export default __exports__